<template>
  <div class="body-wrapper">
    <div>
      <h4>Transakcije</h4>
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-show="!loading">
          <div class="btns-wrapper">
            <button
              class="btn btn-primary"
              @click="showModalWider('ModalContentTransactionIncome')"
            >
              <span>Nova uplata</span>
              <i class="fas fa-plus"></i>
            </button>
            <button
              class="btn btn-danger"
              @click="showModal('ModalContentTransactionPayout')"
            >
              <span>Nova isplata</span>
              <i class="fas fa-minus"></i>
            </button>
          </div>
          <data-table
            :columns="tableColumns"
            :tableData="tableData"
            :options="tableOptions"
            :slotNameActionCommunityFinancesTransactions="'action'"
            :slotTransactionsIncome="'income'"
            :slotTransactionsExpense="'expense'"
            :slotTransactionsBalance="'balance'"
          ></data-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import axios from '@/axios/axios.js';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  components: {
    DataTable
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('finances', ['transactions']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  async created() {
    this.setTableBadge('fas fa-cash-register');
    this.initTable('communityFinancesTransactionsTable');
    await this.getTableData({
      communityId: this.$store.getters.getActiveCommunity.id,
      tableName: 'transactions'
    });
    this.transactions.data.forEach(tx => {
      if (tx.amount < 0) {
        tx.div_description = 'Zajednica stanara';
      } else {
        if (tx.payer) {
          tx.div_description = tx.payer;
        } else {
          const divDesc = tx.div_description ? ` (${tx.div_description})` : '';
          tx.div_description = tx.full_name + divDesc;
        }
      }
    });
    this.setTableData(this.transactions.data);
  },
  methods: {
    ...mapActions('table', ['initTable']),
    ...mapMutations('modal', ['showModal', 'showModalWider']),
    ...mapMutations('table', ['setTableBadge', 'setTableData']),
    ...mapActions('finances', ['getTableData'])
  },
  destroyed() {
    //unsetting table badge
    this.setTableBadge('');
  }
};
</script>
<style lang="scss" scoped>
h4 {
  position: relative;
  margin-bottom: 1rem;
}
.btns-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  .btn {
    width: 150px;
    margin-right: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
